//desmond, 20230216
<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.tournament_match")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                b-input-group(:prepend="$t('ui.room_type')" size="sm")
                  b-form-select(
                    ref="room_type"
                    v-model="roomType"
                    :options="roomTypeList"
                    size="sm"
                    @change="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                b-input-group(:prepend="$t('ui.room_status')" size="sm")
                  b-form-select(
                    ref="room_status"
                    v-model="roomStatus"
                    :options="roomStatusList"
                    size="sm"
                    @change="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-2
                b-button.mr-3(type="button" variant="warning" size="sm" v-b-modal.createRoom)
                  i.fa.fa-plus.mr-1
                  span {{ $t("ui.create_room") }}
                //- b-button(type="button" variant="warning" size="sm" v-b-modal.createRoom2)
                //-   i.fa.fa-plus.mr-1
                //-   span {{ $t("ui.create_room") }} v2
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="roomList" :fields="fields" :filter="filter" thead-class="grey")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(start_time)="row")
                    span {{ $moment(row.item.start_time).format("YYYY-MM-DD HH:mm") }}
                  template(v-slot:cell(room_type)="row")
                    span {{ roomTypeList.find(x => x.value == row.item.room_type).text }}
                  template(v-slot:cell(room_status)="row")
                    span {{ roomStatusList.find(x => x.value == row.item.room_status).text }}
                  template(v-slot:cell(pay_type)="row")
                    span {{ payTypeList.find(x => x.value == row.item.pay_type).text }}
                  template(v-slot:cell(formula)="row")
                    span {{ formulaList.find(x => x.value == row.item.formula).text }}
                  template(v-slot:cell(match)="row")
                    a.pointer.d-inline-block(href="#" data-toggle="modal" v-b-modal.roomMatch @click="setEditSelectedModal(row.item.room_id)")
                      i.fas.fa-info-circle.pointer.icon-dark

      createRoom(@clicked="createRoomComplete")
      //- createRoom2(@clicked="createRoomComplete")
      roomMatch(:roomId="roomId")

</template>

<script>
import config from "@/config"
import SubmitButton from "@/library/SubmitButton.vue"
import createRoom from "@/components/tournament/createRoom.vue"
// import createRoom2 from "@/components/tournament/createRoom2.vue"
import roomMatch from "@/components/tournament/roomMatch.vue"

export default {
  components: {
    SubmitButton,
    createRoom,
    // createRoom2,
    roomMatch
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      roomTypeList: [
        { value: 0, text: this.$t("ui.all") },
        { value: 1, text: this.$t("ui.public") },
        { value: 2, text: this.$t("ui.private") },
        { value: 3, text: this.$t("ui.public_free") },
      ],
      roomStatusList: [
        { value: 10, text: this.$t("ui.all") },
        { value: 0, text: this.$t("ui.active") },
        { value: 1, text: this.$t("ui.close_room") },
        { value: 2, text: this.$t("ui.cancel") },
        { value: 3, text: this.$t("ui.end") },
        { value: 4, text: this.$t("ui.close_bet") }
      ],
      payTypeList: [
        { value: 1, text: this.$t("ui.basic") },
        { value: 2, text: this.$t("ui.plus") }
      ],
      formulaList: [
        { value: 1, text: this.$t("ui.three_winner") },
        { value: 2, text: this.$t("ui.one_winner") }
      ],
      roomStatus: 0,
      roomType: 0,
      roomList: [],
      filter: null,
      sortBy: "room_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      roomId: ""
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "room_id",
          label: this.$t("ui.room_id"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "room_rate",
          label: this.$t("ui.entry_points"),
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "room_host",
          label: this.$t("ui.room_host"),
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "start_time",
          label: this.$t("ui.start_time"),
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "room_type",
          label: this.$t("ui.room_type"),
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "system_id",
          label: this.$t("ui.operator"),
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "room_count",
          label: this.$t("ui.players_joined"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "room_status",
          label: this.$t("ui.status"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "total_league",
          label: this.$t("ui.total_league"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "total_match",
          label: this.$t("ui.total_match"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "room_limit",
          label: this.$t("ui.players"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "pool",
          label: this.$t("ui.pool"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "jackpot",
          label: this.$t("ui.jackpot"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "pay_type",
          label: this.$t("ui.pay_type"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "formula",
          label: this.$t("ui.formula"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "reason",
          label: this.$t("ui.reason"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "action_by",
          label: this.$t("ui.action_by"),
          class: "text-left",
          thClass: "bg-grey",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "match",
          label: this.$t("ui.match"),
          class: "text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "4%"
          }
        }
      ];
    },
    perPage() {
      return this.$store.getters.pageSize
    }
  },
  mounted: function() {
    this.submit();
  },
  beforeDestroy: function() {
    this.submission.success = true
    this.submission.status = ""
    this.roomStatus = 0
    this.roomType = 0
    this.roomList = []
    this.filter = null
    this.sortDesc = true
    this.currentPage = 1
    this.totalRows = 0
    this.roomId = ""
  },
  methods: {
    setEditSelectedModal: function(roomId) {
      this.roomId = roomId
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    submit: function() {
      let room_status = this.roomStatus
      let room_type = this.roomType;
      let page_number = this.currentPage;
      this.currentPage = parseInt(page_number);
      let page_size = this.perPage;
      this.loading = true
      this.$store
        .dispatch("user/getTournamentRoomList", { room_status, room_type, page_number, page_size })
        .then(response => {
          this.loading = false
          this.submission.success = response.success;
          if (this.submission.success == true) {
            this.roomList = response.data
            this.totalRows = response.data.length > 0 ? this.roomList[0]["totalrows"] : 0;
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
    createRoomComplete() {
      this.submit();
    }
  }
};
</script>
